// src/Layout.jsx
import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './components/common/Navbar';
import ProjectCodeNavbar from './components/common/projectCodeNavBar/ProjectCodeNavbar';

const Layout = () => {
  const { pathname } = useLocation();
  const hideNavbar = pathname === '/login_register';
  const hideProjectCodeNavbar = [
    '/', 
    '/assessment', 
    '/login_register', 
    '/learner-details',
    '/products',
    '/pricing',
    '/talktous',
    '/termsAndPolicy'
  ].includes(pathname);

  return (
    <>
      {!hideNavbar && <Navbar />}
      {!hideProjectCodeNavbar && <ProjectCodeNavbar />}
      <Outlet />
    </>
  );
};

export default Layout;